
export { getDeviceByViewportWidth } from "/home/runner/work/apollo/apollo/packages/core/utils/device/src/get-device-by-viewport-width/get-device-by-viewport-width.ts"